import * as types from '../../action-types';
import { createUser as initialState } from '../initialStates';

const createUser = (state = initialState, action) => {
    const { payload, type } = action;

    switch (type) {
        case types.CREATE_USER_START:
            return {
                ...state,
                isLoading: true,
            }
        case types.CREATE_USER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isSuccessful: true,
                data: payload
            }
        case types.CREATE_USER_FAIL:
            return {
                ...state,
                isLoading: false,
                error: payload
            }
        case types.CREATE_USER_CLEANUP:
            return {
                ...state,
                data: null,
                isSuccessful: false,
                error: null,
            }
        default:
            return state;
    };
};

export default createUser;
